<template>
  <div class="tg-feast" data-testid="thanksgiving-feast">
    <div class="tg-feast__backdrop" />

    <div class="tg-feast__title">
      <p class="tg-feast__heading">Happy Thanksgiving!</p>
      <p class="tg-feast__sub">From all of us at Order Protection</p>
    </div>

    <div class="tg-feast__stage">
      <div class="tg-feast__guest" :class="guestClasses">
        <ThanksgivingTurkey :moves="guestMoves" />
        <span v-if="guestMoves === TurkeyMoves.SHOCK" class="tg-feast__gasp">!</span>
      </div>

      <svg class="tg-feast__table" viewBox="0 0 640 260" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern :id="`${uid}-plaid`" width="40" height="40" patternUnits="userSpaceOnUse">
            <rect width="40" height="40" fill="#9a3412" />
            <rect width="40" height="12" y="14" fill="#5b1fd3" opacity="0.55" />
            <rect width="12" height="40" x="14" fill="#5b1fd3" opacity="0.55" />
            <rect width="40" height="2" y="19" fill="#fbbf24" opacity="0.6" />
            <rect width="2" height="40" x="19" fill="#fbbf24" opacity="0.6" />
          </pattern>
        </defs>

        <g class="tg-feast__candle tg-feast__candle--1">
          <rect x="226" y="86" width="10" height="60" rx="2" fill="#fef3c7" />
          <path class="tg-feast__flame" d="M231 66c5 6 6 10 6 13a6 6 0 0 1-12 0c0-3 1-7 6-13z" fill="#fbbf24" />
        </g>
        <g class="tg-feast__candle tg-feast__candle--2">
          <rect x="404" y="86" width="10" height="60" rx="2" fill="#fef3c7" />
          <path class="tg-feast__flame" d="M409 66c5 6 6 10 6 13a6 6 0 0 1-12 0c0-3 1-7 6-13z" fill="#fbbf24" />
        </g>

        <path d="M0 150h640v110H0z" :fill="`url(#${uid}-plaid)`" />
        <path d="M0 150h640v8H0z" fill="#7c2d12" opacity="0.5" />

        <g class="tg-feast__dish tg-feast__dish--cranberry">
          <ellipse cx="60" cy="152" rx="40" ry="8" fill="#e5e7eb" />
          <path d="M38 148v-34c0-4 44-4 44 0v34c0 4-44 4-44 0z" fill="#b91c1c" />
          <path d="M38 126c0 3 44 3 44 0M38 137c0 3 44 3 44 0" stroke="#7f1d1d" stroke-width="2" fill="none" />
          <ellipse cx="60" cy="114" rx="22" ry="4" fill="#dc2626" />
        </g>
        <g class="tg-feast__dish tg-feast__dish--pie">
          <ellipse cx="160" cy="153" rx="50" ry="9" fill="#e5e7eb" />
          <path d="M114 146c0-12 92-12 92 0v4c0 6-92 6-92 0z" fill="#b45309" />
          <ellipse cx="160" cy="141" rx="44" ry="11" fill="#d97706" />
          <ellipse cx="160" cy="141" rx="36" ry="8" fill="#c2410c" />
          <path d="M150 133c0-6 20-6 20 0 0 4-20 4-20 0z" fill="#fffbeb" />
        </g>
        <g class="tg-feast__dish tg-feast__dish--roast">
          <ellipse cx="320" cy="152" rx="96" ry="14" fill="#e5e7eb" />
          <ellipse cx="320" cy="150" rx="84" ry="9" fill="#d1d5db" />
          <ellipse cx="320" cy="116" rx="64" ry="38" fill="#b45309" />
          <ellipse cx="306" cy="104" rx="34" ry="16" fill="#d97706" opacity="0.8" />
          <ellipse cx="258" cy="128" rx="20" ry="13" fill="#9a3412" />
          <ellipse cx="382" cy="128" rx="20" ry="13" fill="#9a3412" />
          <circle cx="238" cy="122" r="6" fill="#fffbeb" />
          <circle cx="236" cy="132" r="6" fill="#fffbeb" />
          <circle cx="402" cy="122" r="6" fill="#fffbeb" />
          <circle cx="404" cy="132" r="6" fill="#fffbeb" />
          <path
            d="M244 146c6-6 14-6 18 0M378 146c4-6 12-6 18 0"
            stroke="#16a34a"
            stroke-width="5"
            stroke-linecap="round"
          />
        </g>
        <g class="tg-feast__dish tg-feast__dish--potatoes">
          <path d="M456 132h84c0 14-18 22-42 22s-42-8-42-22z" fill="#e5e7eb" />
          <path d="M462 132c0-20 72-20 72 0z" fill="#fef3c7" />
          <path d="M478 124c8-8 32-8 40 0-6 6-34 6-40 0z" fill="#92400e" />
          <rect x="491" y="112" width="14" height="9" rx="2" fill="#fde047" />
        </g>
        <g class="tg-feast__dish tg-feast__dish--corn">
          <ellipse cx="596" cy="152" rx="38" ry="8" fill="#e5e7eb" />
          <path d="M566 146c-4-10 6-34 16-34s14 22 10 34z" fill="#facc15" />
          <path d="M594 146c-4-10 6-30 15-30s12 20 9 30z" fill="#fde047" />
          <path
            d="M562 148c6-10 14-14 22-10M590 148c8-8 18-10 26-4"
            stroke="#65a30d"
            stroke-width="5"
            stroke-linecap="round"
          />
        </g>
      </svg>
    </div>

    <span v-for="leaf in confetti" :key="leaf.id" class="tg-feast__confetti" :style="leaf.style">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path :d="MAPLE_LEAF" :fill="leaf.colour" />
      </svg>
    </span>
  </div>
</template>

<script setup lang="ts">
import ThanksgivingTurkey, { TurkeyMoves } from './ThanksgivingTurkey.vue';

enum GuestPhase {
  FLEE = 'flee',
  HIDDEN = 'hidden',
  PEEK = 'peek',
}

const MAPLE_LEAF =
  'M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z';
const LEAF_COLOURS = ['#b91c1c', '#ea580c', '#f59e0b', '#a16207', '#dc2626'];
const CONFETTI_COUNT = 18;

// When the guest turkey peeks up, spots the roast, and bolts (ms after the feast starts).
const GUEST_TIMELINE: Array<[number, GuestPhase, TurkeyMoves]> = [
  [3200, GuestPhase.PEEK, TurkeyMoves.IDLE],
  [4100, GuestPhase.PEEK, TurkeyMoves.SHOCK],
  [4900, GuestPhase.FLEE, TurkeyMoves.STRUT],
];

const uid = useId();
const guestPhase = ref<GuestPhase>(GuestPhase.HIDDEN);
const guestMoves = ref<TurkeyMoves>(TurkeyMoves.IDLE);
const timers: Array<ReturnType<typeof setTimeout>> = [];

const guestClasses = computed(() => ({ [`tg-feast__guest--${guestPhase.value}`]: true }));

const confetti = Array.from({ length: CONFETTI_COUNT }, (_, id) => {
  const angle = (Math.PI * 2 * id) / CONFETTI_COUNT + Math.random() * 0.4;
  const distance = 28 + Math.random() * 22;

  return {
    colour: LEAF_COLOURS[id % LEAF_COLOURS.length],
    id,
    style: {
      '--tg-dx': `${Math.round(Math.cos(angle) * distance)}vw`,
      '--tg-dy': `${Math.round(Math.sin(angle) * distance * 0.8)}vh`,
      '--tg-spin': `${Math.round(Math.random() * 720 - 360)}deg`,
    },
  };
});

onMounted(() => {
  GUEST_TIMELINE.forEach(([at, phase, moves]) => {
    timers.push(
      setTimeout(() => {
        guestPhase.value = phase;
        guestMoves.value = moves;
      }, at),
    );
  });
});

onBeforeUnmount(() => timers.forEach(clearTimeout));
</script>
